import { useContext, useMemo } from 'react';
import MenuOptionLabel from '~/constants/srp/MenuOptionLabel';
import { useFacetData } from '~/context/common/FacetDataContext';
import SearchContext from '~/context/srp/SearchContext';
import Make from './Make';
import FilterDrawer from '../FilterDrawer';

export default function MakeModel() {
  const { expandOnOpen } = useContext(SearchContext);
  const expandSection = expandOnOpen === MenuOptionLabel.MakeModel;
  const facetData = useFacetData();
  const makes = useMemo(
    () => Object.values(facetData.makes ?? {}),
    [facetData.makes]
  );

  return (
    <FilterDrawer
      testId="facet-make-model"
      facetContent={makes}
      facetName="Make & Model"
      defaultExpanded={expandSection}
    >
      <div className="grid gap-xl">
        {makes.map(make => (
          <Make {...make} key={make.key} make={make.key} />
        ))}
      </div>
    </FilterDrawer>
  );
}
